import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import {Smartphone, Mail, MapPin} from 'lucide-react'

export default function Footer() {
  const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 })

  useEffect(() => {
    const calculateCountdown = () => {
      const christmas2026 = new Date('2026-12-25T00:00:00')
      const now = new Date()
      const diff = christmas2026.getTime() - now.getTime()

      if (diff > 0) {
        const days = Math.floor(diff / (1000 * 60 * 60 * 24))
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((diff % (1000 * 60)) / 1000)

        setCountdown({ days, hours, minutes, seconds })
      }
    }

    calculateCountdown()
    const interval = setInterval(calculateCountdown, 1000)

    return () => clearInterval(interval)
  }, [])

  return (
    <footer className="bg-blue-950 text-white border-t border-red-600/30">
      {/* Santa Tracker 2026 Countdown */}
      <div className="bg-gradient-to-r from-red-600 to-blue-900 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-2xl font-bold mb-4">Santa Tracker 2026 Countdown</h3>
          <div className="flex justify-center gap-4 sm:gap-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 min-w-[80px]">
              <div className="text-3xl sm:text-4xl font-bold">{countdown.days}</div>
              <div className="text-sm sm:text-base text-white/80">Days</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 min-w-[80px]">
              <div className="text-3xl sm:text-4xl font-bold">{countdown.hours}</div>
              <div className="text-sm sm:text-base text-white/80">Hours</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 min-w-[80px]">
              <div className="text-3xl sm:text-4xl font-bold">{countdown.minutes}</div>
              <div className="text-sm sm:text-base text-white/80">Minutes</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 min-w-[80px]">
              <div className="text-3xl sm:text-4xl font-bold">{countdown.seconds}</div>
              <div className="text-sm sm:text-base text-white/80">Seconds</div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="bg-red-600 p-2 rounded-lg">
                <Smartphone className="w-6 h-6 text-white" />
              </div>
              <span className="text-2xl font-bold">Texting<span className="text-red-500">Santa</span></span>
            </div>
            <p className="text-white/70 mb-4">
              The official Santa Communication Hub for the texting generation. Connect with the North Pole in 2025 & 2026!
            </p>
            <div className="flex items-center space-x-2 text-white/60">
              <MapPin className="w-5 h-5" />
              <span>North Pole, Arctic Circle</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Modern Traditions</h4>
            <ul className="space-y-2 text-white/70">
              <li><Link to="/tracker" className="hover:text-red-400 transition-colors">Live Santa Tracker</Link></li>
              <li><Link to="/blog" className="hover:text-red-400 transition-colors">Text vs. Letters</Link></li>
              <li><Link to="/faq" className="hover:text-red-400 transition-colors">Santa Cam FAQ</Link></li>
              <li><a href="#" className="hover:text-red-400 transition-colors">Santa Selfie Gallery</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg mb-4">Get in Touch</h4>
            <ul className="space-y-2 text-white/70">
              <li className="flex items-center space-x-2">
                <Mail className="w-5 h-5" />
                <span>santa@textingsanta.com</span>
              </li>
              <li><Link to="/privacy" className="hover:text-red-400 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/contact" className="hover:text-red-400 transition-colors">Contact Us</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-8 pt-8 text-center text-white/60">
          <p>&copy; 2025 TextingSanta.com - All Rights Reserved. Powered by North Pole Technology.</p>
        </div>
      </div>
    </footer>
  )
}
